const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/socials.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/socials')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: (s: Record<string, unknown>) => ({
    openChat: typeof s?.openChat === 'string' ? s.openChat : undefined,
    create: s?.create === '1' || s?.create === true,
    park: typeof s?.park === 'string' ? s.park : undefined
  })
});